import React from 'react';
import { View, Text } from 'react-native';
import { t } from 'i18n-js';
import { isWeb } from '@helpers';

const MachinesGroupPopupBtn = ({ C, name, customStyle, setIsPopupActive, Svg, TouchableElement, isWeb: isWebProp, tourId }) => {
  const webProps = isWeb && tourId ? { dataSet: { tourId } } : {};

  return (
    <TouchableElement onPress={() => setIsPopupActive((e) => !e)}>
      {({ boxStyle }) => (
        <View
          style={[
            boxStyle,
            {
              height: 25,
              width: 133,
              borderRadius: 18,
              flexDirection: 'row',
              paddingHorizontal: 12,
              paddingVertical: 3,
              justifyContent: 'space-between',
              alignItems: 'center',
              ...customStyle,
            },
          ]}
          {...webProps}
        >
          <Text
            style={[
              { color: C('Button/Light/Secondary Text'), marginRight: 10 },
              isWebProp && {
                userSelect: 'none',
              },
            ]}
            numberOfLines={1}
          >
            {name || t('All machines')}
          </Text>
          <Svg icon="chevronBottomLight" width={15} height={17} color={C('Button/Light/Secondary Text')} />
        </View>
      )}
    </TouchableElement>
  );
};

export default MachinesGroupPopupBtn;
